var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddVehicleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_18265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 14.4167C9.91667 11.5 12.0833 9.16667 14.9167 8.83333C15.1667 8 15.9167 7.41667 16.75 7.41667C17.8333 7.41667 18.6667 8.25 18.6667 9.33333V9.66667C19.0833 10 19.5 10.3333 19.9167 10.75V7.41667L18.4167 1C18.4167 1 18.25 0 17.1667 0H2.5C1.5 0 1.33333 1 1.33333 1L0 7.41667V17.0833C0 17.4167 0.333333 17.5833 0.333333 17.5833H3.16667C3.5 17.5833 3.41667 17.0833 3.41667 17.0833V15H10C10 14.8333 9.91667 14.5833 9.91667 14.4167ZM3.08333 11.3333C2 11.3333 1.16667 10.5 1.16667 9.41667C1.16667 8.33333 2 7.5 3.08333 7.5C4.16667 7.5 5 8.33333 5 9.41667C5 10.4167 4.16667 11.3333 3.08333 11.3333ZM3.16667 6.41667H1.5L2.58333 1.66667C2.58333 1.66667 2.75 1.25 3.41667 1.25H16.4167C17.1667 1.33333 17.25 1.66667 17.25 1.66667L18.3333 6.41667H3.16667Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 10.0833C13.2502 10.0833 11.3335 12 11.3335 14.4166C11.3335 16.8333 13.2502 18.75 15.6668 18.75C18.0835 18.75 20.0002 16.8333 20.0002 14.4166C20.0002 12.0833 18.0835 10.0833 15.6668 10.0833ZM16.5835 15.4166V18.1666H14.7502V15.4166H12.0002V13.5833H14.7502V10.8333H16.5835V13.5833H19.3335V15.4166H16.5835Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_18265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddVehicleFill);
export default __webpack_public_path__ + "static/media/icon_add_vehicle_fill.276255742c48cc4b6bd86e2380039be3.svg";
export { ForwardRef as ReactComponent };